import { Alert } from '@mui/material';
import i18n from 'i18n';

const ConnectionQualityNotification = () => (
  <Alert
    severity="warning"
    sx={{
      width: '100%',
    }}
  >
    {i18n.t('notifications:weak_connection')}
  </Alert>
);

export default ConnectionQualityNotification;
